const ggt = {
  parameters: [
    {
      name: 'GGT-female',
      displayName: 'GGT',
      id: 'ggt',
      validFrom: '2026/04/06 1:00',
      validThrough: null,
      interpretationsSupported: ['normal', 'too-high', 'fault'],
      criteria: {
        sexe: ['female'],
        age: {
          min: 5,
          max: 110,
        },
      },
      ranges: [
        {
          color: '#1f7359',
          description: 'GGT-female-normal',
          lowerLimit: 0,
          lowerLimitOperator: '>=',
          upperLimit: 40,
          upperLimitOperator: '<',
          unit: 'U/l',
          interpretation: 'normal',
          displayInterpretation: 'Normal',
          rangeInterpretation: '0 - 39',
        },
        {
          color: '#f52d0a',
          description: 'GGT-female-too-high',
          lowerLimit: 40,
          lowerLimitOperator: '>=',
          upperLimit: 500,
          upperLimitOperator: '',
          unit: 'U/l',
          interpretation: 'too-high',
          displayInterpretation: 'Too high',
          rangeInterpretation: '>= 40',
        },
      ],
    },
    {
      name: 'GGT-male',
      displayName: 'GGT',
      id: 'ggt',
      validFrom: '2026/04/06 1:00',
      validThrough: null,
      interpretationsSupported: ['normal', 'too-high', 'fault'],
      criteria: {
        sexe: ['male'],
        age: {
          min: 5,
          max: 110,
        },
      },
      ranges: [
        {
          color: '#1f7359',
          description: 'GGT-male-normal',
          lowerLimit: 0,
          lowerLimitOperator: '>=',
          upperLimit: 60,
          upperLimitOperator: '<',
          unit: 'U/l',
          interpretation: 'normal',
          displayInterpretation: 'Normal',
          rangeInterpretation: '0 - 59',
        },
        {
          color: '#f52d0a',
          description: 'GGT-male-too-high',
          lowerLimit: 60,
          lowerLimitOperator: '>=',
          upperLimit: 500,
          upperLimitOperator: '',
          unit: 'U/l',
          interpretation: 'too-high',
          displayInterpretation: 'Too high',
          rangeInterpretation: '>= 60',
        },
      ],
    },
  ],
};

export default ggt;
